(function () {
  'use strict';

  /* global FormData */
  class ImportacaoPontoReferenciaCtrl {

    constructor(Uos, Flash, $scope, HttpServiceV3g, moment, PontoReferenciaResourceService, $uibModal) {
      this.uoService = Uos;
      this.flash = Flash;
      this.scope = $scope;
      this.httpService = HttpServiceV3g;
      this.uos = [];
      this.uo = null;
      this.files = [];
      this.moment = moment;
      this.PontoReferenciaResourceService = PontoReferenciaResourceService;
      this.ImportacaoRelatorio = null;
      this.table = null;
      this.httpStatus = 0;
      this.modalService = $uibModal;
      this.init();
      this.loadUos();

      this.scope.uploadedFile = (element) => {
        this.scope.$apply((scope) => {
          scope.files = element.files;
        });
      };
    }

    init() {
      this.periodoFiltro = {startDate: this.moment().subtract(1, 'days'), endDate: this.moment()};
    }

    loadUos() {
      this.uoService.getFilhasLista().then(data => {
        this.uos = data.plain();
      });
    }

    importar() {
      var formData = new FormData();
      this.clearMensagens();
      formData.append('file', this.scope.files[0]);
      formData.append('uoId', this.uo.id);

      this.httpService.post('/embarque/resources/ponto-referencia/uploadCSVPontosParaUO', formData, {
        transformRequest: angular.identity,
        headers: {'Content-Type': undefined}
      })
        .success((data) => {
          if (angular.isDefined(data.mensagens) && data.mensagens.length > 0) {
            this.msgSucessoComErro = data;
          } else {
            this.msgSucesso = 'Processo de importação iniciado';
          }
        })
        .error((data, status) => {
          this.httpStatus = status;
          if (status === 409) {
            this.flash.create('error', 'Importação em andamento para esta UO. Aguarde a conclusão.');
          } else if (angular.isDefined(data.mensagens) && data.mensagens.length > 0) {
            this.flash.create('error', data.mensagens[0]);
          } else {
            this.flash.create('error', 'Erro ao importar.');
          }
        });
    }

    carregarRelatorio() {
      this.PontoReferenciaResourceService.one().get(this.getParams()).then(
        data=> {
          this.ImportacaoRelatorio = data.list;
        }
      );
    }

    getParams() {
      return {
        inicio: this.periodoFiltro.startDate.toDate(),
        fim: this.periodoFiltro.endDate.toDate(),
        uoId: this.uo.id
      };
    }

    clearMensagens() {
      this.msgErro = null;
      this.msgSucesso = null;
      this.msgSucessoComErro = null;
    }

    mostrarMotivoImportacao(importacaoRegistro) {
      if (importacaoRegistro.statusImportacao === 'CONCLUIDO' || importacaoRegistro.statusImportacao === 'IMPORTANDO') {
        return;
      }
      this.modalService.open({
        templateUrl: 'importacao-ponto-referencia/importacao-motivo.tpl.html',
        controller: 'ImportacaoMotivoCtrl',
        controllerAs: 'importacaoMotivo',
        size: 'md',
        resolve: {
          importacaoRegistro: () => importacaoRegistro
        }
      });
    }
  }

  class ImportacaoMotivoCtrl {

    constructor(importacaoRegistro) {
      this.importacaoRegistro = importacaoRegistro;
    }
  }
  /**
   * @ngdoc object
   * @name importacaoPontoReferencia.controller:ImportacaoPontoReferenciaCtrl
   *
   * @description
   *
   */
  angular
    .module('importacaoPontoReferencia')
    .controller('ImportacaoPontoReferenciaCtrl', ImportacaoPontoReferenciaCtrl)
    .controller('ImportacaoMotivoCtrl', ImportacaoMotivoCtrl);
}());
